export const Teams = ({size = 21, className = ''}) => {
  return (
    <i style={{width: size, height: size}} className={`flex justify-center items-center ${className}`}>
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="24" width="16" height="16" rx="1" stroke="currentColor" strokeWidth="3"/>
        <rect x="2" y="2" width="16" height="16" rx="1" stroke="currentColor" strokeWidth="3"/>
        <rect x="24" y="2" width="16" height="16" rx="1" stroke="currentColor" strokeWidth="3"/>
        <path d="M24 31H40" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
        <path d="M32 39L32 23" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    </i>
  )
};
